module.exports = __webpack_public_path__ + "static/img/2.fdbc0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/2.png
// module id = BoVg
// module chunks = 12